export default __webpack_public_path__ + "static/media/linkedin.75fb3e1f.png";